// extracted by mini-css-extract-plugin
export var lbContainerOuter = "z_t6";
export var lbContainerInner = "z_t7";
export var movingForwards = "z_t8";
export var movingForwardsOther = "z_t9";
export var movingBackwards = "z_vb";
export var movingBackwardsOther = "z_vc";
export var lbImage = "z_vd";
export var lbOtherImage = "z_vf";
export var prevButton = "z_vg";
export var nextButton = "z_vh";
export var closing = "z_vj";
export var appear = "z_vk";